import Flex from 'components/atoms/Flex/Flex'

const SGShadows = () => (
  <Flex horizontal>
    <Flex elevation='low' theme='info'>
      <h1>Some Title</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Laboriosam quia eaque magnam quas, dignissimos earum fugiat qui. In, nesciunt fugit provident at numquam saepe, dolorum ab libero voluptas magnam neque?
      </p>
    </Flex>
    <Flex elevation='medium' theme='info'>
      <h1>Some Title</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Laboriosam quia eaque magnam quas, dignissimos earum fugiat qui. In, nesciunt fugit provident at numquam saepe, dolorum ab libero voluptas magnam neque?
      </p>
    </Flex>
    <Flex elevation='high' theme='info'>
      <h1>Some Title</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Laboriosam quia eaque magnam quas, dignissimos earum fugiat qui. In, nesciunt fugit provident at numquam saepe, dolorum ab libero voluptas magnam neque?
      </p>
    </Flex>
  </Flex>
)

export default SGShadows
